import { FilterType } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { compositeFilterAssetsValidator, defaultCompositeFilterAssets } from './assets';
import { compositeFilterCdnOptionsValidator, defaultCompositeFilterCdnOptions } from './cdn-options';
import { compositeFilterConfigValidator, defaultCompositeFilterConfigFilm, defaultCompositeFilterConfigShowtime, defaultCompositeFilterConfigSubscription } from './config';
import { compositeFilterDisplayTextValidator, defaultCompositeFilterDisplayText } from './display-text';
export const compositeFilterPropsValidator = Validator.object({
    filterId: Validator.nonEmptyString,
    config: compositeFilterConfigValidator,
    displayText: compositeFilterDisplayTextValidator,
    assets: compositeFilterAssetsValidator,
    cdnOptions: compositeFilterCdnOptionsValidator
});
export const defaultCompositeFilterPropsFilm = {
    filterId: undefined,
    config: defaultCompositeFilterConfigFilm,
    displayText: defaultCompositeFilterDisplayText,
    assets: defaultCompositeFilterAssets,
    cdnOptions: defaultCompositeFilterCdnOptions
};
export const defaultCompositeFilterPropsShowtime = {
    filterId: undefined,
    config: defaultCompositeFilterConfigShowtime,
    displayText: defaultCompositeFilterDisplayText,
    assets: defaultCompositeFilterAssets,
    cdnOptions: defaultCompositeFilterCdnOptions
};
export const defaultCompositeFilterPropsSubscription = {
    filterId: undefined,
    config: defaultCompositeFilterConfigSubscription,
    displayText: defaultCompositeFilterDisplayText,
    assets: defaultCompositeFilterAssets,
    cdnOptions: defaultCompositeFilterCdnOptions
};
export const defaultCompositeFilterPropsProvider = props => {
    var _a;
    switch ((_a = props.config) === null || _a === void 0 ? void 0 : _a.filterType) {
        case FilterType.Film:
            return defaultCompositeFilterPropsFilm;
        case FilterType.Showtime:
            return defaultCompositeFilterPropsShowtime;
        case FilterType.Subscription:
            return defaultCompositeFilterPropsSubscription;
        default:
            return defaultCompositeFilterPropsFilm;
    }
};
//# sourceMappingURL=props.js.map